import { useEffect } from 'react';

/**
 * Custom hook to update the browser document title.
 * Formats the title as: {title} | Kanea
 * 
 * @param title The title of the current page
 */
const usePageTitle = (title: string) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} | Kanea`;
    } else {
      document.title = 'Kanea';
    }
  }, [title]);
};

export default usePageTitle;
